// extracted by mini-css-extract-plugin
export default {"page":"BuyerGuide_page__LoO6I","container":"BuyerGuide_container__TDoLC"};